import { Switchboard } from "../../../events";
import $ from 'jquery';
export var ToolbarButtonGroup;
(function (ToolbarButtonGroup) {
    ToolbarButtonGroup["None"] = "None";
    ToolbarButtonGroup["Group"] = "GroupActionButton";
})(ToolbarButtonGroup || (ToolbarButtonGroup = {}));
export class ToolbarButton {
    constructor(icon, description, id, title = '', buttonGroup = ToolbarButtonGroup.None) {
        this.icon = icon;
        this.description = description;
        this.id = id;
        this.title = title;
        this.buttonGroup = buttonGroup;
        this.bound_contexts = [];
        this.receiver = Switchboard.get_receiver("CONTEXT");
        this.broadcaster = Switchboard.get_emitter("INTERACTION");
        this.ui = this.create_ui();
        this.receiver.on('ctx_change', (new_context) => {
            if (this.visible_in(new_context))
                this.ui.removeClass('hidden');
            else
                this.ui.addClass('hidden');
        });
    }
    exit_actions() {
        this.broadcaster.emit('i_request', '');
    }
    bind(...ctxs) {
        for (let c of ctxs) {
            this.bound_contexts.push(c);
        }
        return this;
    }
    visible_in(ctx) {
        return this.bound_contexts.length > 0 ? this.bound_contexts.includes(ctx.name) : true;
    }
    create_ui() {
        if (this.id === 'placeholder_button') {
            return $(`<span class="toolbar-separator"></span>`);
        }
        const btn = $(`<button id="${this.id}"></button>`);
        const img = $(`<i class='fas fa-${this.icon}'></i>`);
        img.attr("title", this.description);
        btn.append(img);
        if (this.buttonGroup === ToolbarButtonGroup.Group && this.title) {
            btn.css('width', `${this.title.length * 10}px`);
            btn.css('text-align', 'left');
            btn.append(`<span style="margin-left:5px; font-size:14px">${this.title}</span>`);
        }
        btn.on('click', (e) => {
            btn.toggleClass("highlighted");
            this.exit_actions();
            this._action(e);
        });
        return btn;
    }
}
